import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NgModel }          from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { EmailVerificationService } from './email-verification.service';
import { MessagesService }          from '../messages/messages.service';

@Component({
  selector   : 'wor-email-verification',
  template: require('./email-verification.component.html')
})
export class EmailVerificationComponent implements OnInit {
  @Input() label : string;
  @Input() model : string;
  @Input() name  : string;

  @Output() modelChange: EventEmitter<boolean> = new EventEmitter();

  originalEmail : string;

  constructor (
    private emailVerificationService : EmailVerificationService,
    private messagesService          : MessagesService,
    private router                   : UIRouter,
    private translateService         : TranslateService
  ) {}

  ngOnInit(): void {
    this.originalEmail = this.model;
  }

  didVerificationFail () : boolean {
    return !this.hasEmailChanged()
      && this.emailVerificationService.didVerificationFail();
  }

  getEmailLabel ( email : NgModel ) : string {
    let status = '';

    if ( email.dirty && email.invalid ) {
      return this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_EMAIL');
    }

    if ( this.isEmailPending() ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.PENDING');
    }
    else if ( this.isEmailVerified() ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.VERIFIED');
    }
    else if ( this.didVerificationFail() ) {
      status = this.translateService.instant('JS_SPACE.EMAIL.VERIFICATION_FAILED');
    }
    else {
      status = this.translateService.instant('JS_SPACE.EMAIL.UNVERIFIED');
    }

    return `${ this.label || this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL') } (${ status })`;
  }

  hasEmailChanged () : boolean {
    return this.model !== this.originalEmail;
  }

  isEmailPending () : boolean {
    return !this.hasEmailChanged()
      && this.emailVerificationService.isEmailPending();
  }

  isEmailUnverified () : boolean {
    return this.hasEmailChanged()
      || this.emailVerificationService.isEmailUnverified();
  }

  isEmailVerified () : boolean {
    return !this.hasEmailChanged()
      && this.emailVerificationService.isEmailVerified();
  }

  verifyEmail () : void {
    this.emailVerificationService.verify()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.EMAIL.VERIFICATION_SENT_MESSAGE'), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }
}